import { render, staticRenderFns } from "./matchHDPOUOEOdds.vue?vue&type=template&id=eca12774&lang=pug&"
import script from "./matchHDPOUOEOdds.vue?vue&type=script&lang=js&"
export * from "./matchHDPOUOEOdds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports